const questions = [
  {
    tag: 'reciprocity',
    text: '來店消費就送價值888元福袋'
  },
  {
    tag: 'reciprocity',
    text: 'CP值最高！買一件就送一件 超值驚喜組'
  },
  {
    tag: 'reciprocity',
    text: '消費滿兩千免費加入會員，立即享有八折優惠'
  },
  {
    tag: 'commitment',
    text: '愛環保的妳一定會喜歡，綠色時尚即將風襲全球'
  },
  {
    tag: 'commitment',
    text: '個性女生最有態度的有機衣著'
  },
  {
    tag: 'commitment',
    text: '保護動物拒用皮草！讓妳的美麗時尚不血腥'
  },
  {
    tag: 'identity',
    text: '東京熱銷TOP1春日連身洋裝'
  },
  {
    tag: 'identity',
    text: '回購率100%！每個小資女都要擁有的優雅上班鞋'
  },
  {
    tag: 'identity',
    text: '風靡美日・超過十萬人搶購的超顯瘦oversize牛仔外套'
  },
  {
    tag: 'authority',
    text: '「最會穿搭的第一夫人」秘密衣櫃套裝精選'
  },
  {
    tag: 'authority',
    text: '時尚教主秘笈公開！完美下半身單品挑選指南'
  },
  {
    tag: 'authority',
    text: '巴黎潮流・傳奇設計師再現經典'
  },
  {
    tag: 'preference',
    text: '回頭率百分百！不敗單品幫妳輕鬆打造美麗自信'
  },
  {
    tag: 'preference',
    text: '穿上它氣質滿分！高貴不昂貴的手工訂製皮鞋'
  },
  {
    tag: 'preference',
    text: '上班族最愛 ♡ 專利修身輕盈襯衫系列'
  },
  {
    tag: 'rarity',
    text: '限時24小時下單！倫敦新銳設計師純手工打造訂製款小禮服'
  },
  {
    tag: 'rarity',
    text: '最後一雙！今夏獨家限定款球鞋'
  },
  {
    tag: 'rarity',
    text: 'LIMITED SALE 紐約最潮設計師全球限量配件'
  }
];

export default questions;



// WEBPACK FOOTER //
// ./app/data/questions.js